// extracted by mini-css-extract-plugin
module.exports = {"wrpr":"Tooltip_wrpr__VUhJC","dialog":"Tooltip_dialog__SoblT","darkMode":"Tooltip_darkMode__xzIqZ","closeIcon":"Tooltip_closeIcon__UVNvF","infoIcon":"Tooltip_infoIcon__LerON"};